import { isElementInsideRoom } from "../isElementInsideRoom";
import { sumElementMultipliers } from "../../sumElementMultipliers";
import type { CountElementsByRoom, RoomGroupCount } from "./types";

// An element inside several rooms is counted in each of them; groups with nothing inside are skipped.
export const countElementsByRoom: CountElementsByRoom = ({
  rooms,
  groupIds,
  byGroupId,
}) =>
  rooms.map((room) => {
    const groups = groupIds.flatMap<RoomGroupCount>((label) => {
      const elements = (byGroupId[label] ?? []).filter((element) =>
        isElementInsideRoom({ element, room }),
      );
      if (elements.length === 0) return [];
      return [
        {
          label,
          quantity: sumElementMultipliers({ elements }),
          rgb: elements[0].rgb,
        },
      ];
    });
    const total = groups.reduce((sum, group) => sum + group.quantity, 0);
    return { room, groups, total };
  });
